import { render, staticRenderFns } from "./PopUpGenerateReports.vue?vue&type=template&id=4bb4c682&"
import script from "./PopUpGenerateReports.vue?vue&type=script&lang=ts&"
export * from "./PopUpGenerateReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports